document.addEventListener("DOMContentLoaded", function() {
  const results = {
    energie: {
      title: "Énergie & vitalité",
      text: "Votre priorité semble être de retrouver plus d’énergie, de réduire la fatigue et de soutenir votre vitalité au quotidien.",
      mainLabel: "Lire l’article recommandé sur l’énergie",
      mainUrl: "https://pureshilajithimalaya.fr/blogs/quels-sont-les-bienfaits-du-shilajit/comment-retrouver-energie-et-vitalite-apres-40-ans",
      related: [
        { label: "Épuisement fréquent", url: "https://pureshilajithimalaya.fr/blogs/quels-sont-les-bienfaits-du-shilajit/fatigue-persistante-optimisez-naturellement-votre-apport-en-oxygene-et-en-nutriments" },
        { label: "Régénération cellulaire", url: "https://pureshilajithimalaya.fr/blogs/quels-sont-les-bienfaits-du-shilajit/pourquoi-votre-corps-perd-il-en-tonus" }
      ]
    },

    stress: {
      title: "Stress & sommeil",
      text: "Votre priorité semble être d’apaiser la pression mentale, de mieux récupérer et de retrouver un sommeil plus réparateur.",
      mainLabel: "Lire l’article recommandé sur le stress",
      mainUrl: "https://pureshilajithimalaya.fr/blogs/quels-sont-les-bienfaits-du-shilajit/comment-reduire-le-stress-naturellement",
      related: [
        { label: "Troubles du sommeil", url: "https://pureshilajithimalaya.fr/blogs/quels-sont-les-bienfaits-du-shilajit/troubles-du-sommeil-comment-retrouver-un-repos-reparateur-naturellement" },
        { label: "Fatigue liée à l’âge", url: "https://pureshilajithimalaya.fr/blogs/quels-sont-les-bienfaits-du-shilajit/comment-retrouver-energie-et-vitalite-apres-40-ans" }
      ]
    },

    immunite: {
      title: "Immunité",
      text: "Votre priorité semble être de renforcer vos défenses naturelles et de soutenir votre organisme face aux périodes de baisse de forme.",
      mainLabel: "Lire l’article recommandé sur l’immunité",
      mainUrl: "https://pureshilajithimalaya.fr/blogs/quels-sont-les-bienfaits-du-shilajit/comment-renforcer-naturellement-un-systeme-immunitaire-faible",
      related: [
        { label: "Détoxifier son corps naturellement", url: "https://pureshilajithimalaya.fr/blogs/quels-sont-les-bienfaits-du-shilajit/detoxifier-son-corps-naturellement-comment-purifier-ses-tissus-en-profondeur" },
        { label: "Régénération cellulaire", url: "https://pureshilajithimalaya.fr/blogs/quels-sont-les-bienfaits-du-shilajit/pourquoi-votre-corps-perd-il-en-tonus" }
      ]
    },

    recuperation: {
      title: "Récupération physique",
      text: "Votre priorité semble être d’améliorer votre récupération après l’effort et d’aider votre corps à mieux se régénérer.",
      mainLabel: "Lire l’article recommandé sur la récupération",
      mainUrl: "https://pureshilajithimalaya.fr/blogs/quels-sont-les-bienfaits-du-shilajit/comment-favoriser-une-recuperation-optimale-selon-la-science",
      related: [
        { label: "Testostérone basse", url: "https://pureshilajithimalaya.fr/blogs/quels-sont-les-bienfaits-du-shilajit/testosterone-en-berne-comment-relancer-naturellement-votre-energie" },
        { label: "Épuisement fréquent", url: "https://pureshilajithimalaya.fr/blogs/quels-sont-les-bienfaits-du-shilajit/fatigue-persistante-optimisez-naturellement-votre-apport-en-oxygene-et-en-nutriments" }
      ]
    },

    libido: {
      title: "Libido & vitalité hormonale",
      text: "Votre priorité semble être de soutenir votre vitalité intime, votre énergie masculine et votre équilibre hormonal.",
      mainLabel: "Lire l’article recommandé sur la libido",
      mainUrl: "https://pureshilajithimalaya.fr/blogs/quels-sont-les-bienfaits-du-shilajit/manque-de-libido-comprendre-le-probleme-et-retrouver-une-vitalite-naturelle",
      related: [
        { label: "Testostérone basse", url: "https://pureshilajithimalaya.fr/blogs/quels-sont-les-bienfaits-du-shilajit/testosterone-en-berne-comment-relancer-naturellement-votre-energie" },
        { label: "Fatigue persistante", url: "https://pureshilajithimalaya.fr/blogs/quels-sont-les-bienfaits-du-shilajit/fatigue-persistante-optimisez-naturellement-votre-apport-en-oxygene-et-en-nutriments" }
      ]
    },

    cerveau: {
      title: "Concentration & mémoire",
      text: "Votre priorité semble être de soutenir votre clarté mentale, votre attention et vos fonctions cognitives.",
      mainLabel: "Lire l’article recommandé sur la concentration",
      mainUrl: "https://pureshilajithimalaya.fr/blogs/quels-sont-les-bienfaits-du-shilajit/concentration-mentale-causes-de-la-perte-dattention-et-solutions-naturelles",
      related: [
        { label: "Mémoire et fonctions cognitives", url: "https://pureshilajithimalaya.fr/blogs/quels-sont-les-bienfaits-du-shilajit/memoire-et-fonctions-cognitives-soutenir-naturellement-la-sante-du-cerveau" },
        { label: "Stress et pression mentale", url: "https://pureshilajithimalaya.fr/blogs/quels-sont-les-bienfaits-du-shilajit/comment-reduire-le-stress-naturellement" }
      ]
    },

    digestion: {
      title: "Digestion & équilibre interne",
      text: "Votre priorité semble être de soutenir votre confort digestif, votre microbiote et l’équilibre interne de votre organisme.",
      mainLabel: "Lire l’article recommandé sur la digestion",
      mainUrl: "https://pureshilajithimalaya.fr/blogs/quels-sont-les-bienfaits-du-shilajit/le-shilajit-et-la-sante-digestive",
      related: [
        { label: "Détoxification naturelle", url: "https://pureshilajithimalaya.fr/blogs/quels-sont-les-bienfaits-du-shilajit/detoxifier-son-corps-naturellement-comment-purifier-ses-tissus-en-profondeur" },
        { label: "Acides fulviques", url: "https://pureshilajithimalaya.fr/blogs/quels-sont-les-bienfaits-du-shilajit/shilajit-et-acides-fulviques-pourquoi-sont-ils-si-puissants-pour-la-sante" }
      ]
    }
  };

const quizzes = document.querySelectorAll(".psh-quiz-bienfaits");

quizzes.forEach(function(quiz) {
  const buttons = quiz.querySelectorAll("button[data-result]");
  const resultDiv = quiz.querySelector(".psh-quiz-result");

  if (!buttons.length || !resultDiv) return;

  buttons.forEach(function(button) {
    button.addEventListener("click", function() {
      const key = this.getAttribute("data-result");
      const data = results[key];

      if (!data) return;

      let relatedHtml = "";

      if (data.related && data.related.length) {
        relatedHtml = `
          <div class="psh-related-title">Articles complémentaires :</div>
          <div class="psh-related-links">
            ${data.related.map(function(item) {
              return `<a href="${item.url}" class="psh-related-link">${item.label}</a>`;
            }).join("")}
          </div>
        `;
      }

      resultDiv.innerHTML = `
        <div class="psh-result-box">
          <h3>${data.title}</h3>
          <p>${data.text}</p>
          <a href="${data.mainUrl}" class="psh-main-link">${data.mainLabel}</a>
          ${relatedHtml}
        </div>
      `;
    });
  });
});
});